module.exports = __webpack_public_path__ + "static/media/flexibility.6433ad63.svg";